<template>
    <div class="form-group">
        <label :for="dsId" v-if="dsLabel != null">{{ dsLabel }}</label>
        <input
            :type="dsType"
            :name="dsName"
            :placeholder="dsPlaceholder"
            :class="dsClass"
            :id="dsId"
            @keyup.passive="action($event.target.value)"
            :disabled="dsDisabled"
        />
    </div>
</template>

<script>
export default {
    name: 'sp-input',
    data: function () {
        return {}
    },
    props: {
        dsId: {
            type: String,
            required: true
        },
        dsName: {
            type: String,
            required: true
        },
        dsType: {
            type: String,
            required: true
        },
        dsLabel: {
            type: String,
            required: false
        },
        dsClass: {
            type: String,
            required: false
        },
        dsPlaceholder: {
            type: String,
            required: false
        },
        dsDisabled: {
            type: Boolean,
            required: false,
            default: false
        },
        value: {
            type: [String, null]
        }
    },
    methods: {
        action (value) {
            this.$emit('input', value)
        }
    }
}
</script>

<style lang="scss">
input {
    border: 1px solid transparent;
    padding: 9px 14px;
    font-size: 0.9rem;
    width: 100%;
    outline: none;
    position: relative;

    &.dark {
        color: $white;
        background: #131C26;
    }

    &.icon {
        &:after {
            content: '';
            display: inline-block;
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        }

        &.icon-search {
            &:after {
                width: 16px;
                height: 16px;
                background: url("../../assets/icons/icon-search.svg");
            }
        }
    }
}
</style>
